export default "__VITE_ASSET__C3Dp$fws__";